export default __webpack_public_path__ + "static/featureCards_immersive-2b8b276dcab783c513a2d86d684daf4b.mp4";